import React from 'react';

export enum SpacerSize {
  LG = 'lg',
  MD = 'md',
  SM = 'sm',
}

interface SpacerProps {
  size?: SpacerSize;
}

const sizeClasses: Record<SpacerSize, string> = {
  [SpacerSize.SM]: 'h-2',
  [SpacerSize.MD]: 'h-4',
  [SpacerSize.LG]: 'h-8',
};

export const Spacer: React.FC<SpacerProps> = ({size = SpacerSize.MD}) => <div className={sizeClasses[size]} aria-hidden="true" />;
